import TireconnectLocationHtml from './tireconnect.location.html';

export function TireconnectSettingsService (
  $uibModal,
  $translate,
  confirm,
  workshopAPI
) {
  const TireconnectSettings = function (integrationSettings) {
    this.integrationSettings = integrationSettings;
    this.name                = 'TireConnect';
  };

  TireconnectSettings.prototype.activate = function () {
    const self = this;

    return confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: self.name }))
    .then(() => workshopAPI.get('/company_integration/add_tireconnect'));
  };

  TireconnectSettings.prototype.areAllProductsEmpty = function () {
    const self = this;

    return !self.integrationSettings.tireconnect_install_balance_product_id &&
      !self.integrationSettings.tireconnect_tyre_recycling_fee_product_id &&
      !self.integrationSettings.tireconnect_valve_stem_tpms_product_id &&
      !self.integrationSettings.tireconnect_other_product_id;
  };

  TireconnectSettings.prototype.defaultAllProducts = function (product = {}) {
    const self = this;

    self.integrationSettings.tireconnect_install_balance_product_id        = product.id;
    self.integrationSettings.tireconnect_tyre_recycling_fee_product_id     = product.id;
    self.integrationSettings.tireconnect_valve_stem_tpms_product_id        = product.id;
    self.integrationSettings.tireconnect_other_product_id                  = product.id;
    self.integrationSettings.tireconnect_install_balance_product_name      = product.item_code;
    self.integrationSettings.tireconnect_tyre_recycling_fee_product_name   = product.item_code;
    self.integrationSettings.tireconnect_valve_stem_tpms_product_name      = product.item_code;
    self.integrationSettings.tireconnect_other_product_name                = product.item_code;

    return self.integrationSettings;
  };

  TireconnectSettings.prototype.handleProductSelect = function (product = {}, key) {
    const self = this;

    if (self.areAllProductsEmpty()) {
      self.defaultAllProducts(product);
    }
    else {
      switch (key) {
        case 'install_balance':
          self.integrationSettings.tireconnect_install_balance_product_id   = product.id;
          self.integrationSettings.tireconnect_install_balance_product_name = product.item_code;
          break;
        case 'recycling':
          self.integrationSettings.tireconnect_tyre_recycling_fee_product_id   = product.id;
          self.integrationSettings.tireconnect_tyre_recycling_fee_product_name = product.item_code;
          break;
        case 'tpms':
          self.integrationSettings.tireconnect_valve_stem_tpms_product_id   = product.id;
          self.integrationSettings.tireconnect_valve_stem_tpms_product_name = product.item_code;
          break;
        default:
          self.integrationSettings.tireconnect_other_product_id   = product.id;
          self.integrationSettings.tireconnect_other_product_name = product.item_code;
          break;
      }
    }
  };

  TireconnectSettings.prototype.includeLaborLines = function () {
    const self = this;

    return !self.integrationSettings.tireconnect_no_labour_lines;
  };

  TireconnectSettings.prototype.remove = function () {
    const self = this;

    return confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.REMOVE', { name: self.name }))
    .then(() => workshopAPI.get('/company_integration/remove_tireconnect'));
  };

  TireconnectSettings.prototype.save = function () {
    const self = this;

    return workshopAPI.patch('/company_integrations', self.integrationSettings, 'company_integration')
    .then(integrations => workshopAPI.get('/tireconnect/get_locations', null, 'locations'))
    .then(locations => {
      return $uibModal.open({
        templateUrl: TireconnectLocationHtml,
        windowClass: 'lg-modal flip-container',
        controller: 'TireconnectLocationCtrl',
        resolve: {
          locations () {
            return locations;
          }
        }
      }).result;
    });
  };

  TireconnectSettings.prototype.saveLabor = function () {
    const self = this;

    return workshopAPI.patch('/company_integrations', self.integrationSettings, 'company_integration');
  };

  return TireconnectSettings;
}
